import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link
            to="/"
            className="inline-flex items-center text-secondary-600 hover:text-primary-600 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back to Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-secondary-900 mb-2">Terms of Service</h1>
        <p className="text-secondary-500 text-sm mb-8">Last updated: February 2026</p>

        <div className="prose prose-secondary max-w-none space-y-6 text-secondary-700">
          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using myoneqr (“Service”), you agree to these Terms of Service. If you do not agree, do not use the Service. We may update these terms; continued use after changes means you accept the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">2. Description of Service</h2>
            <p>
              myoneqr is a platform that lets you create a digital profile with links, collaborations, QR codes, and analytics. Features and limits depend on your plan (Trial, Free, Basic, or Premium).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">3. Account and Eligibility</h2>
            <p>
              You must provide accurate information when signing up. You are responsible for keeping your password secure and for all activity under your account. You must be at least 13 years old (or the minimum age in your jurisdiction) to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">4. Subscription and Payments</h2>
            <p>
              We offer Trial, Free, Basic, and Premium plans. Paid plans are billed in INR via our payment provider (Razorpay). By subscribing, you agree to recurring charges until you cancel. Refund and cancellation rules are as stated at the time of purchase. You can cancel through Account settings or by contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">5. Your Content and Conduct</h2>
            <p>
              You keep ownership of the content you add. You grant us a license to store, display, and operate on this content to provide the Service. You must not use the Service to post illegal, harmful, offensive, or infringing content. We may remove content and suspend or terminate accounts that violate these terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">6. Public Profiles</h2>
            <p>
              Profile pages may be publicly accessible. Do not add content you do not want to be public. You are responsible for what you publish.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">7. Disclaimers and Limitation of Liability</h2>
            <p>
              The Service is provided “as is.” We do not guarantee uninterrupted or error-free operation. To the fullest extent permitted by law, our liability is limited to the amount you paid us in the twelve months before the claim, or ₹100, whichever is greater. We are not liable for indirect, incidental, or consequential damages.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">8. Termination</h2>
            <p>
              We may suspend or terminate your account if you breach these terms. You may delete your account via Account settings. On termination, your right to use the Service ends.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-2">9. Governing Law and Contact</h2>
            <p>
              These terms are governed by the laws of India. For questions, contact us via the support email or phone listed on the website.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200">
          <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">
            ← Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
